import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Type } from '@angular/core';
import { Request } from './models/request-response';
import { GenericApiService, GenericBoundedApiService } from './generic-api.service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

@Injectable({ providedIn: 'root' })
export class GenericApiServiceFactory {
    constructor(private _http: HttpClient, @Inject(SETTINGS) private _settings: ISettings) {}

    public create(endpointUrl?: string): GenericApiService | GenericBoundedApiService {
        return endpointUrl
            ? new GenericBoundedApiService(this._http, this._settings, endpointUrl)
            : new GenericApiService(this._http, this._settings);
    }

    public createBounded<TRequest extends Request = Request>(
        endpointUrl: string,
        requestType: Type<TRequest> = null
    ): GenericBoundedApiService {
        return new GenericBoundedApiService(this._http, this._settings, endpointUrl, requestType);
    }
}
